import { render, staticRenderFns } from "./LoosingNewBreadcrumbButton.component.vue?vue&type=template&id=e913e994&scoped=true&"
import script from "./LoosingNewBreadcrumbButton.component.vue?vue&type=script&lang=js&"
export * from "./LoosingNewBreadcrumbButton.component.vue?vue&type=script&lang=js&"
import style0 from "./LoosingNewBreadcrumbButton.component.vue?vue&type=style&index=0&id=e913e994&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e913e994",
  null
  
)

export default component.exports